import { ApplicationUuid, OPTIMIZATION_TYPE, Team } from '@bringg/types';

import { teamHasFeatureFlag } from './feature-flags';

export const COMBINED_OPTIMIZATION_ROLLOUT_FF = 'combined_optimization_rollout';
export const AUTODISPATCH_DELIVERY_BLOCK_RESOURCES_FF = 'autodispatch_delivery_block_resources';

// Resolution order: RouteOptimizer2 first, VrpAutoDispatch as the fallback for AutoDispatch-only merchants.
const COMBINED_OPTIMIZATION_APPLICATIONS = [ApplicationUuid.RouteOptimizer2, ApplicationUuid.VrpAutoDispatch];

type OptimizationTypeConfig = { optimization_type?: OPTIMIZATION_TYPE } | null | undefined;

export type MerchantApplicationConfigSource = {
	getConfiguration: (appUuid: ApplicationUuid) => OptimizationTypeConfig;
};

export type TeamApplicationConfigSource = {
	getConfigData: (appUuid: ApplicationUuid, teamId: number) => OptimizationTypeConfig;
};

export const hasCombinedOptimization = ({
	team,
	merchantConfigs,
	teamConfigs,
	isAutoDispatchResourcesEnabled
}: {
	team: Team | undefined;
	merchantConfigs: MerchantApplicationConfigSource;
	teamConfigs: TeamApplicationConfigSource;
	isAutoDispatchResourcesEnabled: boolean;
}): boolean => {
	if (teamHasFeatureFlag(team, COMBINED_OPTIMIZATION_ROLLOUT_FF)) {
		return true;
	}

	if (!isAutoDispatchResourcesEnabled) {
		return (
			merchantConfigs.getConfiguration(ApplicationUuid.RouteOptimizer2)?.optimization_type ===
			OPTIMIZATION_TYPE.COMBINED
		);
	}

	return COMBINED_OPTIMIZATION_APPLICATIONS.some(appUuid => {
		// Team-level value wins per field; an undefined team value falls through to the merchant value,
		// mirroring ApplicationConfigurationProvider.getConfigs on the backend.
		const teamOptimizationType = team ? teamConfigs.getConfigData(appUuid, team.id)?.optimization_type : undefined;
		const optimizationType =
			teamOptimizationType !== undefined
				? teamOptimizationType
				: merchantConfigs.getConfiguration(appUuid)?.optimization_type;

		return optimizationType === OPTIMIZATION_TYPE.COMBINED;
	});
};
